export const sentryToken = Symbol('sentryValueInjectionToken')
export const httpToken = Symbol('httpValueInjectionToken')
export const requestToken = Symbol('requestValueInjectionToken')
export const responseToken = Symbol('responseValueInjectionToken')
export const requestContainerToken = Symbol(
  'requestContainerValueInjectionToken'
)
export const redirectToken = Symbol('redirectValueInjectionToken')
